import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { LoginPromptDialogData } from './login-prompt-dialog.data';

@Component({
  selector: 'app-login-prompt',
  templateUrl: './login-prompt.component.html',
  styleUrls: ['./login-prompt.component.scss'],
})
export class LoginPromptComponent {
  readonly isOutOfHours: boolean;
  readonly confirmationDeadline: string;

  constructor(
    private readonly dialogRef: MatDialogRef<LoginPromptComponent>,
    private readonly router: Router,
    @Inject(MAT_DIALOG_DATA) data: LoginPromptDialogData | null,
  ) {
    this.isOutOfHours = Boolean(data?.isOutOfHours);
    this.confirmationDeadline = data?.confirmationDeadline ?? '';
  }

  get showOvernightCopy(): boolean {
    return this.isOutOfHours && !!this.confirmationDeadline;
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onLogin(): void {
    this.dialogRef.close('login');
    this.router.navigate(['./auth', 'login']);
  }

  onCreateAccount(): void {
    this.dialogRef.close('signup');
    this.router.navigate(['./auth', 'sign-up']);
  }

  onModifyAmount(): void {
    this.dialogRef.close('modify_amount');
  }
}
